import { useMemo } from "react";
import { useSnackbarQuery } from "../../hooks";
import { BuildingMedia } from "../models/BuildingMedia";
import { QUERIES } from "../queries";

export function useBuildingRoomDefaultMedia(buildingId: string) {
  const { data, loading, error } = useSnackbarQuery(
    QUERIES.BUILDING_DEFAULT_ROOM_MEDIA_PICTURE,
    {
      variables: {
        buildingId,
      },
    }
  );

  const buildingRoomDefaultMediaPicture: BuildingMedia | undefined =
    useMemo(() => {
      if (data) {
        return data.buildingDefaultRoomMediaPicture;
      }
    }, [data]);

  return { buildingRoomDefaultMediaPicture, loading, error };
}
